// time type formatting
export const valueFormatTimeConvert = (value) => {
  var seconds = parseInt(value),
    minutes, hours, days, hhmmss;

  // If seconds variable is not a number then set seconds to 0
  if (isNaN(seconds)) { seconds = 0; }

  // Calculate the days, hours, minutes and seconds
  days = Math.floor(seconds / 86400);
  hours = Math.floor((seconds - (days * 86400)) / 3600);
  minutes = Math.floor((seconds - (hours * 3600 + days * 86400)) / 60);
  seconds = Math.floor(seconds - (days * 86400 + hours * 3600 + minutes * 60));

  // Check for single digits then change to double
  if (seconds < 10) { seconds = '0' + seconds; }
  if (minutes < 10) { minutes = '0' + minutes; }
  if (hours < 10) { hours = '0' + hours; }

  // Check if the time is more than one day, if so display days in the returned string
  hhmmss = hours + ':' + minutes + ':' + seconds;
  return (days > 0) ? days + ' ' + hhmmss : hhmmss;
}

// time type formatting
export const valueFormatTimeConvertLetters = (value, isStat) => {
  var seconds = parseInt(value),
    minutes, hours, days,
    output = '';

  // If seconds variable is not a number then set seconds to 0
  if (isNaN(seconds)) { seconds = 0; }

  // Calculate the days, hours, minutes and seconds
  days = Math.floor(seconds / 86400);
  seconds -= (days * 86400);

  hours = Math.floor(seconds / 3600) % 24;
  seconds -= (hours * 3600);

  minutes = Math.floor(seconds / 60) % 60;
  seconds -= (minutes * 60);


  if (days > 0) {
    output = days + 'd '
  }
  if (days > 0 || hours > 0) {
    output += (' ' + hours + 'h ');
  }
  if (days > 0 || hours > 0 || minutes > 0) {
    output += (' ' + minutes + 'm');
  }
  if (isStat && seconds > 0) {
    output += (' ' + seconds + 's');
  }
  if (output.length === 0) {
    return isStat ? '0s' : '0m';
  }
  return output;
}

export default { valueFormatTimeConvert, valueFormatTimeConvertLetters };